/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_OverlineInputs */

const en_cp_why_overline = /** @type {(inputs: Cp_Why_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHY LECTURERS CAN TRUST IT`)
};

const id_cp_why_overline = /** @type {(inputs: Cp_Why_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MENGAPA DOSEN BISA PERCAYA`)
};

/**
* | output |
* | --- |
* | "WHY LECTURERS CAN TRUST IT" |
*
* @param {Cp_Why_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_overline = /** @type {((inputs?: Cp_Why_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_overline(inputs)
	return en_cp_why_overline(inputs)
});